import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'

function StudentBList() {
  const location = useLocation()
  const [data, setData] = useState([])
  const [students, setStudents] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const batch_id = new URLSearchParams(location.search).get('batch_id')

  const getStudents = async () => {
    setLoading(true)
    let url = `${process.env.REACT_APP_BASE_URL}getallstudents?batch_id=${batch_id}`
    try {
      const response = await axios.get(url)
      if (response.status === 200) {
        setData(response.data)
      }
    } catch (error) {
      console.error('Error fetching students:', error)
    }
    setLoading(false)
  }

  useEffect(() => {
    getStudents()
  }, [batch_id])

  const checkStudent = (item) => {
    let index = students.indexOf(item)
    let studentsTemp = students.slice()
    if (index > -1) {
      studentsTemp.splice(index, 1)
    } else {
      studentsTemp.push(item)
    }
    setStudents(studentsTemp)
  }

  const handleSubmitAssign = async (e) => {
    e.preventDefault()
    if (students.length === 0) {
      toast.error('Please choose student')
    } else {
      let dataSend = {
        batch_id: batch_id,
        students: students,
      }
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BASE_URL}delete_batch_student`,
          dataSend,
          {
            withCredentials: true,
          }
        )
        if (data) {
          toast.success('Student Deleted Successfully.')
          window.location.reload(true)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  // Map data for easier rendering
  const mappedData = data.map((item, index) => ({
    id: item._id,
    sNo: String(index + 1).padStart(2, '0'),
    name: `${item.first_name || ''} ${item.middle_name || ''} ${
      item.last_name || ''
    }`
      .replace(/ +/g, ' ')
      .trim(),
    email: item.email,
    school: item.school,
    phone: item.phone,
    isSelected: students.includes(item._id),
    raw: item,
  }))

  return (
    <div className="w-full mt-2.5 max-md:max-w-full">
      <div className="justify-between items-center border border-[color:var(--Stock,#F0F0F0)] flex w-full gap-4 font-medium leading-[1.2] flex-wrap bg-white px-5 py-3.5 rounded-[10px_10px_0px_0px] border-solid max-md:max-w-full">
        <div className="text-[#030303] text-lg self-stretch my-auto">
          Assign Students From Batch
        </div>
        <div className="flex gap-2">
          <button
            className="justify-center items-stretch flex flex-col text-xs text-white text-center w-[100px] bg-[#DE3C7D] my-auto p-2.5 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
            type="button"
            onClick={() => navigate('/batches')}
          >
            <div className="flex w-full gap-1">
              <div className="text-white">Back</div>
            </div>
          </button>
          {data.length > 0 && (
            <button
              className="justify-center items-stretch flex flex-col text-xs text-white text-center w-[160px] bg-[#DE3C7D] my-auto p-2.5 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
              type="submit"
              onClick={handleSubmitAssign}
            >
              <div className="flex w-full gap-1">
                <div className="text-white">Delete Students</div>
              </div>
            </button>
          )}
        </div>
      </div>
      {/* Table Header */}
      <div className="flex w-full bg-neutral-50 border-b border-l border-r border-[#F0F0F0]">
        <div className="w-20 flex-none px-4 py-3.5 border-r border-[#F0F0F0]"></div>
        <div className="w-20 flex-none px-4 py-3.5 border-r border-[#F0F0F0] text-center">
          S.No
        </div>
        <div className="w-60 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Student Name
        </div>
        <div className="w-80 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Email Address
        </div>
        <div className="w-72 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          School
        </div>
        <div className="w-40 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Phone
        </div>
      </div>
      {/* Table Rows */}
      {loading ? (
        Array.from({ length: 5 }).map((_, idx) => (
          <div
            key={idx}
            className="flex w-full border-b border-l border-r border-[#F0F0F0] bg-white animate-pulse"
          >
            {['w-20', 'w-20', 'w-60', 'w-80', 'w-72', 'w-40'].map((w, i) => (
              <div
                key={i}
                className={`${w} flex-none px-4 py-2 border-r border-[#F0F0F0] flex items-center justify-center`}
              >
                <div className="h-4 w-full bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        ))
      ) : mappedData.length > 0 ? (
        mappedData.map((item, index) => (
          <div
            key={item.id}
            className={`flex w-full border-b border-l border-r border-[#F0F0F0] bg-white ${
              index === mappedData.length - 1 ? 'rounded-b-[10px]' : ''
            }`}
          >
            <div className="w-20 flex-none px-4 py-2 border-r border-[#F0F0F0] flex items-center justify-center">
              <label className="cursor-pointer">
                <input
                  type="checkbox"
                  checked={item.isSelected}
                  onChange={() => checkStudent(item.id)}
                  className="sr-only"
                />
                <span className="inline-block w-4 h-4">
                  {item.isSelected ? (
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/ef7fcf665d69a24f338a53eba4618a706e0d31d1?placeholderIfAbsent=true"
                      className="w-full h-full object-contain"
                      alt="Selected"
                    />
                  ) : (
                    <div className="w-full h-full border border-[color:var(--Text,#535862)] rounded-[3px] border-solid" />
                  )}
                </span>
              </label>
            </div>
            <div className="w-20 flex-none px-4 py-2 border-r border-[#F0F0F0] text-center">
              {item.sNo}
            </div>
            <div className="w-60 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.name}
            </div>
            <div className="w-80 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.email}
            </div>
            <div className="w-72 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.school}
            </div>
            <div className="w-40 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.phone}
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-8 text-[#535862] text-sm border-x border-b border-[color:var(--Stock,#F0F0F0)] bg-white rounded-b-[10px]">
          No Data Available
        </div>
      )}
    </div>
  )
}
export default StudentBList
